import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteListModule } from '@portal-core/ui/list/components/infinite-list/infinite-list.module';
import { AllItemsLoadedListModule } from '@portal-core/ui/list/directives/all-items-loaded-list/all-items-loaded-list.module';
import { EmptyListModule } from '@portal-core/ui/list/directives/empty-list/empty-list.module';
import { ListItemModule } from '@portal-core/ui/list/directives/list-item/list-item.module';
import { SelectListComponent } from './select-list.component';

@NgModule({
  declarations: [
    SelectListComponent
  ],
  imports: [
    AllItemsLoadedListModule,
    CommonModule,
    EmptyListModule,
    InfiniteListModule,
    ListItemModule
  ],
  exports: [
    SelectListComponent
  ]
})
export class SelectListComponentModule { }
